<template>
  <div class="text-white text-sm gap-6 flex flex-col" :class="{ 'border border-[#424242] rounded-xl p-6': hideImages }">
    <div v-if="hideImages">
      <div class="text-20 font-bold">Farklı bir uyum gör</div>
      <div class="text-sm sm:text-md font-normal mt-3">Uyumluluğu yeniden kontrol etmek için sizin ve partnerinizin burcunu seçin</div>
    </div>
    <div class="relative u-center" :class="{ 'justify-center gap-3': hideImages, 'gap-[90px] sm:gap-24': !hideImages }">
      <CompatibilityCardSelect
        :horoscope="horoscope1"
        :hide-images="hideImages"
        :hide-actions="hideActions"
        @update="handleHoroscope1Update"
      />
      <OIcon
        v-if="!hideImages"
        icon="heart-widget"
        svg-class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-36 sm:w-50 h-36 sm:h-50"
      />
      <CompatibilityCardSelect
        :horoscope="horoscope2"
        :hide-images="hideImages"
        :hide-actions="hideActions"
        @update="handleHoroscope2Update"
      />
    </div>
    <!-- buttons -->
    <OButton
      v-if="!hideActions || !isResultPage"
      pure
      class="h-12 px-8 w-full sm:w-auto mx-auto bg-[#6842EF] u-center rounded-full text-lg font-semibold"
      :disabled="!horoscope1 || !horoscope2"
      :class="{ 'opacity-50 cursor-not-allowed': !horoscope1 || !horoscope2 }"
      @click="handleCalculate"
    >
      {{ isResultPage ? 'Uyumu Güncelle' : 'Uyumu Kontrol Et' }}
    </OButton>
  </div>
</template>

<script>
import { defineComponent, ref, useRoute } from '@nuxtjs/composition-api';
import CompatibilityCardSelect from '@/modules/astrology/components/CompatibilityCardSelect.vue';
import { OButton, OIcon } from '@/modules/common/components/ui';
import { getHoroscopeCompatibilityUrl } from '@/modules/astrology/utils/astrologyUtils';

export default defineComponent({
  components: {
    OButton,
    OIcon,
    CompatibilityCardSelect,
  },
  props: {
    hideImages: {
      type: Boolean,
      default: false,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const route = useRoute();
    const horoscope1 = ref(route.value.params.pathMatch ? route.value.params.pathMatch.split('-')[0] : null);
    const horoscope2 = ref(route.value.params.pathMatch ? route.value.params.pathMatch.split('-')[1] : null);
    const isResultPage = horoscope1.value && horoscope2.value;

    const handleCalculate = () => {
      if (!horoscope1.value || !horoscope2.value) {
        return;
      }
      document.location.href = getHoroscopeCompatibilityUrl(horoscope1.value, horoscope2.value);
    };

    const handleHoroscope1Update = (value) => {
      horoscope1.value = value;
      emit('update', horoscope1.value);
    };

    const handleHoroscope2Update = (value) => {
      horoscope2.value = value;
    };

    return {
      horoscope1,
      horoscope2,
      isResultPage,
      handleCalculate,
      handleHoroscope1Update,
      handleHoroscope2Update,
    };
  },
});
</script>
